import tzlookup from "tz-lookup";
import useLocationFromCache from "./useLocationFromCache";

export const useTimeZoneFromLocationId = (locationId: string) => {
  const { getCachedLocation } = useLocationFromCache();

  const location = getCachedLocation(locationId);
  let lat = 0;
  let lon = 0;

  try {
    const data = JSON.parse(location?.locationData || "{}");

    lat = Number(data.lat);

    lon = Number(data.lon);
  } catch (error) {
    console.error("Invalid locationData:", error);
  }

  return tzlookup(lat, lon);
};
